/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LotCurrency = "CHF" | "EUR" | "GBP";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentEnquiry_development$ref: FragmentReference;
declare export opaque type DevelopmentEnquiry_development$fragmentType: DevelopmentEnquiry_development$ref;
export type DevelopmentEnquiry_development = {|
  +id: string,
  +products: $ReadOnlyArray<{|
    +id: string,
    +lotReference: ?string,
    +salePrice: ?number,
    +currency: ?LotCurrency,
    +status: string,
    +property: {|
      +numberOfRooms: ?number,
      +floorOfFlat: ?number,
    |},
  |}>,
  +$refType: DevelopmentEnquiry_development$ref,
|};
export type DevelopmentEnquiry_development$data = DevelopmentEnquiry_development;
export type DevelopmentEnquiry_development$key = {
  +$data?: DevelopmentEnquiry_development$data,
  +$fragmentRefs: DevelopmentEnquiry_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentEnquiry_development",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lotReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfRooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "floorOfFlat",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f833677160bcaec984c31cdc988eb0ac';

export default node;
